module.exports = "<img [src]=\"this.imatge\" >"